import React, { useEffect } from 'react';
import Feedback from '../../Feedback/components/Feedback';
import { useAppState, useAppDispatch } from '../../../AppContext';

const AppFeedback = () => {
  const state = useAppState();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: localStorage.getItem("IsibuteFeedbackMessage"),
      feedbackVariant: localStorage.getItem("IsibuteFeedbackVariant"),
    }));
  }, []);

  return (
    <Feedback
      message={state?.feedbackMessage}
      variant={state?.feedbackVariant}
      closeFeedback={() => {
        dispatch((appState) => ({
          ...appState,
          feedbackMessage: null,
          feedbackVariant: null,
        }));
      }}
    />
  );
};

export default AppFeedback;
